import React from 'react';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
// Official Blinkblis YouTube channel. Replace with the exact channel URL if different.
const YOUTUBE_CHANNEL_URL = 'https://www.youtube.com/@blinkblis_';
export function YouTubeSection() {
  const {
    t
  } = useLanguage();
  return <section className="py-20 md:py-32 relative z-10" data-id="element-373" data-mp="1t4s9zsbq9efv">
      <div className="max-w-7xl mx-auto px-5 sm:px-6" data-id="element-374" data-mp="2qtkgfr8bxmpz">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-16" data-id="element-375" data-mp="2lviwz56zrldz">
          <h2 className="text-[40px] leading-[1.05] md:text-4xl font-display font-medium mb-4" data-id="element-376" data-mp="2lwbt7c8bqshv">
            {t('youtube.title')}
          </h2>
          <p className="text-white/50 text-[18px] leading-[1.5] md:text-lg font-light" data-id="element-377" data-mp="2cvdpkv1ssmzt">
            {t('youtube.subtitle')}
          </p>
        </div>

        <motion.a href={YOUTUBE_CHANNEL_URL} target="_blank" rel="noopener noreferrer" aria-label={t('youtube.cta')} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="relative block aspect-video max-w-5xl mx-auto rounded-[2rem] glass-panel border border-white/10 overflow-hidden group cursor-pointer focus:outline-none focus:ring-2 focus:ring-accent/50" data-id="element-378" data-mp="15ilrgc4oggbe">
          <div className="absolute inset-0 bg-surface/80" data-id="element-379" data-mp="3993eersxi2d" />

          {/* Abstract Video Placeholder */}
          <div className="absolute inset-0 flex items-center justify-center pb-20 md:pb-0" data-id="element-380" data-mp="3kq8ukm23pa4r">
            <div className="relative w-16 h-16 md:w-24 md:h-24 flex items-center justify-center" data-id="element-381" data-mp="3pnshsbgs0x8u">
              <div className="absolute inset-0 bg-accent/20 rounded-full blur-2xl opacity-0 md:group-hover:opacity-100 transition-opacity duration-700" data-id="element-382" data-mp="3boj017cx9v2r" />
              <div className="relative w-14 h-14 md:w-20 md:h-20 rounded-full bg-white/5 backdrop-blur-xl border border-white/10 flex items-center justify-center md:group-hover:scale-110 md:group-hover:bg-white/10 md:group-hover:border-white/20 transition-all duration-500 shadow-[0_8px_32px_rgba(0,0,0,0.4)]" data-id="element-383" data-mp="3gpyjww3d5vjk">
                <Play className="w-6 h-6 md:w-8 md:h-8 text-white ml-1 md:ml-1.5 opacity-90 md:group-hover:opacity-100 transition-opacity" fill="currentColor" data-id="element-384" data-mp="18g8xn8i9pk5k" />
              </div>
            </div>
          </div>

          <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10 bg-gradient-to-t from-background via-background/90 to-transparent flex flex-col md:flex-row md:items-end justify-between gap-4 md:gap-6" data-id="element-385" data-mp="207y8aklb73yu">
            <div data-id="element-386" data-mp="1r6gy1iul1wi2">
              <div className="text-[13px] md:text-sm font-mono text-accent mb-2 md:mb-3 uppercase tracking-widest" data-id="element-387" data-mp="1r93052ypfjsw">
                {t('youtube.badge')}
              </div>
              <h3 className="text-[28px] md:text-3xl font-display font-medium text-white mb-2 leading-tight" data-id="element-388" data-mp="fqa34xlb0uti">
                {t('youtube.videoTitle')}
              </h3>
              <p className="text-white/60 text-[15px] md:text-base font-light max-w-lg" data-id="element-389" data-mp="2wf2zxxwacjdm">
                {t('youtube.videoDesc')}
              </p>
            </div>
            <span className="shrink-0 bg-white text-background px-6 py-3.5 md:py-3 rounded-full text-[15px] md:text-sm font-medium md:group-hover:bg-white/90 md:group-hover:-translate-y-0.5 md:group-hover:shadow-[0_8px_20px_rgba(255,255,255,0.15)] transition-all duration-300 flex items-center justify-center gap-2 w-full md:w-auto mt-2 md:mt-0" data-id="element-390" data-mp="356bpcj0d4nzy">
              {t('youtube.cta')}
            </span>
          </div>
        </motion.a>
      </div>
    </section>;
}